// ** React Imports
import React, {ReactNode} from 'react'

// ** Next Imports
import {Link} from 'react-router-dom'

// ** MUI Components
import Box from '@mui/material/Box'
import { styled, useTheme } from '@mui/material/styles'
import MuiCard, { CardProps } from '@mui/material/Card'
import Typography from '@mui/material/Typography'

// ** Icon Imports
import Icon from 'src/@core/components/icon'

// ** Layout Import
import BlankLayout from 'src/@core/layouts/BlankLayout'

import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import {Divider, Stack} from "@mui/material";


// ** Styled Components
const Card = styled(MuiCard)<CardProps>(({ theme }) => ({
    [theme.breakpoints.up('sm')]: { width: '35rem', height: '18rem' }
}))


const ConfirmAccount = () => {
    const theme = useTheme()

    return (
            <Grid container justifyContent={'center'} alignItems={'center'} sx={{height: '100vh !important'}}>
                <Card sx={{ zIndex: 1 }}>
                    <CardContent sx={{ p: theme => `${theme.spacing(12, 9, 7)} !important` }}>
                        <Stack direction={'row'} justifyContent={'center'}>
                            <Box sx={{objectFit: 'contain', width: 160, height: 61, display: 'flex'}}
                                 component="img"
                                 alt="Logo"
                                 src={`/images/fogaba-resized.png`}
                            />
                        </Stack>
                        <Divider sx={{marginTop: 2}}/>
                        <Box sx={{ mb: 6, mt: 4 }}>
                            <Typography variant='h5' sx={{ fontWeight: 600, mb: 1.5 }}>
                                Su cuenta fue activada exitosamente ✅
                            </Typography>
                            <Typography variant='body2' sx={{mt: 4}}>
                                Puede cerrar esta pestaña o volver al inicio para ingresar a su cuenta
                            </Typography>
                        </Box>
                            <Typography variant='body2' sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 2 }}>
                                <Link to='/login' style={{
                                    display: 'flex',
                                    fontSize: '0.875rem',
                                    alignItems: 'center',
                                    textDecoration: 'none',
                                    justifyContent: 'center',
                                    color: theme.palette.primary.main
                                }}>
                                    <Icon icon='mdi:chevron-left' />
                                    <span>Volver al inicio</span>
                                </Link>
                            </Typography>
                    </CardContent>
                </Card>
            </Grid>
        )
}


ConfirmAccount.getLayout = (page: ReactNode) => <BlankLayout>{page}</BlankLayout>

ConfirmAccount.guestGuard = true

export default ConfirmAccount